var map = {
	"./22_mummy.mp3": "2749",
	"./23_daddy.mp3": "df5e",
	"./24_sister.mp3": "c057",
	"./25_brother.mp3": "ff32",
	"./26_baby.mp3": "709b",
	"./M_Brilliant.mp3": "9abd",
	"./M_Excellent.mp3": "35e7",
	"./M_Fantastic.mp3": "20fd",
	"./M_Great.mp3": "365e",
	"./M_Perfect.mp3": "370b",
	"./M_Think again.mp3": "db05",
	"./M_Try again.mp3": "6ca9",
	"./M_Very good.mp3": "3a68",
	"./M_Well done.mp3": "c8b2",
	"./M_Work harder.mp3": "6d48",
	"./click.mp3": "36d9",
	"./empty_true.mp3": "b217",
	"./false.mp3": "1093",
	"./true.mp3": "e738"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb0d";